export default [ 'preload',
  'scene1',
  'scene2',
  'scene3',
  'scene4',
  'scene5',
  'scene6',
  'scene7',
  'scene8',
  'scene9',
  'scene10'
]



// WEBPACK FOOTER //
// ./src/templates/fashionIcon/scenes.js